import { applyMiddleware, createStore } from "redux";
import logger from "redux-logger";
import thunk from "redux-thunk";
import reducer from "./reducers";

const middleware = applyMiddleware(thunk, logger);

export default createStore(
  reducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), // To use with Redux dev tool extension
  middleware
);



// WEBPACK FOOTER //
// ./src/store.js